export default "__VITE_ASSET__45830a90__"